import type {ReactElement} from 'react';
import React from 'react';
import {IconSize} from '@Components/icon-v2/icon.types';
import {Icon} from '@Components/icon-v2';
import {Text, TextSize} from '@Components/text';
import type {CardProps} from './card.types';
import styles from './card.module.scss';

export function Card({text, subtext = '', subtext2 = '', thumbnailIcon, isThumbnailIconDisabled = false, textIcon, customWidthClass, date, month}: CardProps): ReactElement<any> {
  const getThumbnail = (): ReactElement<any> | undefined => {
    if (thumbnailIcon) {
      return <div className={`${isThumbnailIconDisabled ? 'bg-neutral-3' : 'bg-primary-10'} flex-row-align-center justify-content-center radius-4`}>{thumbnailIcon}</div>;
    }

    if (date && month) {
      return (
        <div className={`${styles.calendarCard} flex-column-align-center justify-content-center`}>
          <div className={`${styles.monthContainer} flex-row-align-center justify-content-center bg-primary-20 _full-width`}>
            <Text val={month} className={`${styles.customTextSizeXXXS} content-primary`} bold />
          </div>
          <div className={`${styles.dateContainer} flex-row-align-center justify-content-center bg-primary-10 _full-width`}>
            <Text val={date.toString()} size={TextSize.XSMALL} className="content-primary" bold />
          </div>
        </div>
      );
    }
    return undefined;
  };

  return (
    <div className={`${styles.container} ${customWidthClass ?? '_full-width'} flex-row-align-center _overflow-hidden`}>
      {getThumbnail()}
      <div className="flex-column-align-start justify-content-center spacing-m-l-3 -truncated-text flex-1">
        <div className="flex-row-align-center -truncated-text _full-width">
          <Text className={`${styles.text} -truncated-text`} val={text} size={TextSize.XSMALL} bold />
          {textIcon ? <Icon className="spacing-m-l-2" icon={textIcon} size={IconSize.SIZE_ICON_20} /> : undefined}
        </div>
        {subtext ? <Text val={subtext} size={TextSize.XXSMALL} className={`${styles.subtext} content-sub-text -truncated-text _full-width`} /> : undefined}
        {subtext2 ? <Text val={subtext2} size={TextSize.XXSMALL} className={`${styles.subtext} content-sub-text -truncated-text _full-width`} /> : undefined}
      </div>
    </div>
  );
}
